<template>
  <div>
    <navigation style="position: absolute; width: 100%"> </navigation>
  </div>
</template>
<script>
import navigation from "../routing/navigation";

export default {
  name: "profile",
  components: {
    navigation,
  },
};
</script>
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/view/Profile.vue